import { useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Portfolio } from "@/components/landing/Portfolio";
import { Pricing } from "@/components/landing/Pricing";
import { Trust } from "@/components/landing/Trust";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";
import { OrderModal } from "@/components/OrderModal";

export default function Landing() {
  const [modal, setModal] = useState({ open: false, tier: "growth", url: "" });

  const openModal = (opts = {}) =>
    setModal({ open: true, tier: opts.tier || "growth", url: typeof opts.url === "string" ? opts.url : "" });

  return (
    <div className="min-h-screen bg-[#0A0B10] text-[#F8F9FA]">
      <Navbar onCreate={() => openModal()} />
      <main>
        <Hero onCreate={(url) => openModal({ url })} />
        <HowItWorks />
        <Portfolio />
        <Pricing onSelect={(tier) => openModal({ tier })} />
        <Trust />
        <FAQ />
      </main>
      <Footer onCreate={() => openModal()} />
      <OrderModal
        open={modal.open}
        initialTier={modal.tier}
        initialUrl={modal.url}
        onClose={() => setModal((m) => ({ ...m, open: false }))}
      />
    </div>
  );
}
